import { Component, Input, OnInit } from '@angular/core';

import { UtilityService } from 'src/app/core/services/utility.service';
import { CustomField } from '../../../../core/api/models/custom-field';
import { EnumsService } from '../../../../core/api/services/enums.service';
import { BaseSelectionList } from '../base/base-selection-list.component';
import { DeliveryStatus } from './../../../../core/api/models/delivery-status';
import { SavedEnumsService } from './../../../../core/services/saved-enums.service';

@Component({
  selector: 'enum-selection-list',
  templateUrl: './enum-selection-list.component.html',
  standalone: false,
})
export class EnumSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  @Input('enumType') input_enumType: any;
  @Input('enumName') input_enumName: string;

  @Input() selectedItems: CustomField[] = []; //selected items

  constructor(
    private utilityService: UtilityService,
    private enumsService: EnumsService
  ) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'name';
    this.sortKey = 'id';

    if (this.input_enumName === 'DeliveryStatus') {
      this.customSortArray = [
        DeliveryStatus.InvalidSender,
        DeliveryStatus.NotSent,
        DeliveryStatus.BlackList,
      ];
    }

    if (!this.input_label) this.input_label = 'common.customFields';
  }

  getItems() {
    if (this.loading) return;
    this.loading = true;
      this.enumsService
        .enumsGetEnumValues({ EnumTypeName: this.input_enumName })
        .pipe(this.baseSelectionSearchPipeOperators)
        .subscribe((items) => {
          SavedEnumsService.pushEnum({
            enumName: this.input_enumName,
            enumValue: items?.data,
          });
          this.items = items?.data.map((item) => {
            return { name: item.value, id: item.key };
          });
        });

    // this.items = this.getEnumItems(this.input_enumType, this.input_enumName);
  }

  getEnumItems(enumType: any, enumName?: string): any[] {
    if (!enumName) {
      return this.utilityService.enumToObject(enumType).map((item) => {
        return { name: item.key, id: item.value };
      });
    }

    return this.utilityService
      .enumToObjectWithTranslate(enumType, enumName)
      .map((item) => {
        return { name: item.key, id: item.value };
      });
  }
}
